import {getWithdrawalsAwaiting} from '../api/getWithdrawalsAwaiting';
import {setGetWithdrawalsAwaitingAction} from '../action';

const setGetWithdrawalsAwaiting = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWithdrawalsAwaiting(params);

            if (data.status === 'success') {
                dispatch(setGetWithdrawalsAwaitingAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetWithdrawalsAwaiting
}